<script setup>
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

const { t } = useI18n();
const inboxes = useMapGetter('inboxes/getWhatsAppInboxes');
</script>

<template>
  <div
    v-if="!inboxes.length"
    role="status"
    class="mx-4 my-3 rounded-lg border border-n-weak bg-n-solid-2 p-4 text-sm text-n-slate-12"
  >
    <p>{{ t('CAMPAIGN.WHATSAPP.OFFICIAL_SETUP_REQUIRED') }}</p>
    <router-link
      :to="{ name: 'settings_inbox_new' }"
      class="mt-2 inline-block text-n-brand underline"
    >
      {{ t('CAMPAIGN.WHATSAPP.CONNECT_OFFICIAL') }}
    </router-link>
  </div>
</template>
